import React, { useState } from "react";
import DynamicVerifyModal from "../../../components/common/VerifyPopUpScreen";
import BadgesComponent from "../../../components/common/Badges";

// import './HFRVerify.css';


type VerifyModalProps = {
    closeVerifyModal:()=>void;
    facilityVerify: any;
  };
  const ABDMVerify = ({
      closeVerifyModal,
      facilityVerify
  }: VerifyModalProps) => {
      const [show, setShow] = useState<boolean>(true);
      const handleClose = () => setShow(false);
      // const facilityVerify=ABDMDetails
      
      const contents=
      <>
         <div className="hfr_verification_popup">
        <BadgesComponent
          className="hfr-over-badge"
          badgeName="Facility Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">Health Facility Type</label>
            <div className="overview-details-value">{facilityVerify?.facility_type}</div>
          </div>
          <div>
            <label className="overview-details-label">Ownership</label>
            <div className="overview-details-value">{facilityVerify?.ownership}</div>
          </div>
          <div>
            <label className="overview-details-label">Facility Name</label>
            <div className="overview-details-value">{facilityVerify?.abdm_facility_name}</div>
            {/* <div>
            <BadgesComponent
          className="hfr-over-badge"
          badgeName="Matching score > 70%"
          variant="success"
          badgeType="case5"
        />
            </div> */}
          </div>
          <div>
            <label className="overview-details-label">Facility Status</label>
            <div className="overview-details-value">{facilityVerify.status}</div>
          </div>
        </div>
      </div>
      <div className="hfr_verification_popup">
        <BadgesComponent
          className="hfr-over-badge"
          badgeName="Location Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">{`${facilityVerify?.state_name}-${facilityVerify?.state_code}`}</div>
          </div>
          <div>
            <label className="overview-details-label">District Name</label>
            <div className="overview-details-value">{`${facilityVerify?.district_name}-${facilityVerify?.district_code}`}</div>
          </div>
          <div>
            <label className="overview-details-label">Sub-District Name</label>
            <div className="overview-details-value">{`${facilityVerify?.sub_district_name}-${facilityVerify?.sub_district_code}`}</div>
          </div>
          <div>
            <label className="overview-details-label">Village/city/town name </label>
            <div className="overview-details-value">{`${facilityVerify?.village_city_town_name}-${facilityVerify?.village_city_town_code}`}</div>
          </div>
        </div>
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">Address</label>
            <div className="overview-details-value">{facilityVerify?.address}</div>
          </div>
          <div>
            <label className="overview-details-label">Latitude</label>
            <div className="overview-details-value">{parseFloat(facilityVerify?.latitude).toFixed(6)}</div>
          </div>
          <div>
            <label className="overview-details-label">Longitude</label>
            <div className="overview-details-value">{parseFloat(facilityVerify?.longitude).toFixed(6)}</div>
          </div>
          <div>
            <label className="overview-details-label">Pincode</label>
            <div className="overview-details-value">{facilityVerify?.pincode}</div>
          </div>
        </div>
      </div>
      </>
    return (
      <DynamicVerifyModal className={"hfr-verify-modal"} title={"ABDM Details"} closeVerifyModal={closeVerifyModal} contents={contents}/>
      );
  };
  
  export default ABDMVerify;
  